export const ru = {
    'approx-duration-lower-boundary-label': '{approximateDuration} дней',
    'approx-price-lower-boundary-label': 'от {approxPrice}',
    'info-line': 'Стоимость и сроки примерные, указаны по данным специалиста'
};
